import React from 'react';
import { Calendar, Map, Sparkles } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: Calendar,
    title: 'Book a Clarity Call',
    description: "A free 15-minute chat to hear your story and see if we're a good fit."
  }, {
    icon: Map,
    title: 'Get Your Roadmap',
    description: "We'll design a personalized nutrition plan tailored to your life."
  }, {
    icon: Sparkles,
    title: 'Build Lasting Habits',
    description: 'Ongoing support and adjustments to help you reach your goals for good.'
  }];
  return <section className="py-24 bg-white" data-id="element-74">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-75">
        <div className="text-center mb-16" data-id="element-76">
          <h2 className="font-serif text-3xl font-bold text-stone-900 sm:text-4xl" data-id="element-77">
            Your Path to Food Freedom
          </h2>
          <p className="mt-4 text-lg text-stone-600" data-id="element-78">
            Simple steps to a healthier relationship with food.
          </p>
        </div>

        <div className="relative grid grid-cols-1 gap-12 md:grid-cols-3" data-id="element-79">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 border-t-2 border-dashed border-stone-200 -z-10" data-id="element-80" />

          {steps.map((step, index) => <div key={index} className="relative flex flex-col items-center text-center" data-id="element-81">
              <div className="flex h-24 w-24 items-center justify-center rounded-full bg-stone-50 border-4 border-white shadow-lg mb-6" data-id="element-82">
                <step.icon className="h-10 w-10 text-emerald-700" data-id="element-83" />
              </div>
              <div className="absolute top-0 right-1/2 translate-x-10 -translate-y-2 bg-stone-900 text-white text-xs font-bold px-2 py-1 rounded-full" data-id="element-84">
                {index + 1}
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-85">
                {step.title}
              </h3>
              <p className="text-stone-600 max-w-xs" data-id="element-86">{step.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}